module.exports = __webpack_public_path__ + "static/media/education.130572c4.jpg";